import { render, staticRenderFns } from "./AssignHospitalToUserDialog.vue?vue&type=template&id=0af5bd30"
import script from "./AssignHospitalToUserDialog.vue?vue&type=script&lang=js"
export * from "./AssignHospitalToUserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports